import styled from "styled-components";

import { BaseWrapper } from "./Sidenote";

export default styled.p`
  font-size: 19px;
  margin-bottom: 32px;

  ${BaseWrapper} & {
    font-size: 17px;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media ${p => p.theme.breakpoints.smAndSmaller} {
    font-size: 18px;
    margin-bottom: 1.5rem;
  }
`;
